import { useI18n } from '../i18n'

export function Sam({
  low, name, high, value, onPick,
}: { low: string; name: string; high: string; value: number | null; onPick: (v: number) => void }) {
  return (
    <div className="sam">
      <div className="sam-label">
        <span>{low}</span>
        <span>{name}</span>
        <span>{high}</span>
      </div>
      <div className="dots">
        {Array.from({ length: 9 }, (_, i) => i + 1).map((i) => (
          <button key={i} className={'dot' + (value === i ? ' sel' : '')} onClick={() => onPick(i)}>
            {i}
          </button>
        ))}
      </div>
    </div>
  )
}

export function Chips({
  items, selected, onToggle, single,
}: { items: string[]; selected: string[]; onToggle: (v: string) => void; single?: boolean }) {
  return (
    <div className="chips">
      {items.map((v) => (
        <button
          key={v}
          className={'chip' + (selected.includes(v) ? ' sel' : '')}
          onClick={() => onToggle(v)}
          aria-pressed={selected.includes(v)}
          data-single={single ? '1' : undefined}
        >
          {v}
        </button>
      ))}
    </div>
  )
}

/** Мягкий шов на профессиональную помощь. Никогда не «лечим». */
export function SupportCard() {
  const { t } = useI18n()
  return (
    <div className="support">
      <b>{t.support.title}</b>
      <p>{t.support.text}</p>
    </div>
  )
}

export function Banner({ text }: { text: string }) {
  return <div className="banner">{text}</div>
}

export function Loading({ msg }: { msg: string }) {
  return (
    <section className="screen">
      <div className="loadbox">
        <div className="pulse-line" />
        <p className="muted">{msg}</p>
      </div>
    </section>
  )
}
